import { useTranslation } from 'react-i18next';

import { FeedbackModalTemplate } from 'modals/Templates';

import ErrorIcon from 'assets/emoji/exclamation2.svg';

const ExpiredSubscriptionDiscountErrorModal = () => {
    const { t } = useTranslation();

    return (
        <FeedbackModalTemplate
            image={ErrorIcon}
            title={t('expiredSubscriptionDiscountErrorModal.title')}
            subtitle={t('expiredSubscriptionDiscountErrorModal.subtitle')}
            withCloseButton
        />
    );
};

export default ExpiredSubscriptionDiscountErrorModal;
